import gql from "graphql-tag";

export const GET_ALL_PRODUCTS = gql`
  query Query {
    getAllProducts
  }
`;
export const GET_USER_SUBSCRIPTION_PLAN = gql`
  query Query {
    getUserPlan
  }
`;

export const GET_SUBSCRIPTION_PLAN = gql`
  query Query {
    getUserTokenPlan
  }
`;

export const DOWNGRADE_PLAN = gql`
  mutation DownGradSubscription($isAnnual: Boolean!, $plan: String!) {
    downGradSubscription(isAnnual: $isAnnual, plan: $plan)
  }
`;

export const CENCEL_SUBSCRIPTION = gql`
  query Query {
    cancelSubscription
  }
`;
